import React from "react";
import styled from "styled-components";

import BranchEmployeeItem from "./BranchEmployeeItem";

const Wrapper = styled.div`
    margin-top: 30px;
    display: flex;
    @media (max-width: 737px) {
        flex-wrap: wrap;
    }
`;

const LeftCol = styled.div`
    width: 200px;
`;

const RightCol = styled.div`
    flex-grow: 1;
`;

const Header = styled.h2`
    color: #ff6c0e !important;
`;

const SalesReps = styled.div`
    display: flex;
    flex-wrap: wrap;
`;

const BranchEmployees = ({ location }) => (
    <React.Fragment>
        <Wrapper>
            {location.branchManager && (
                <LeftCol>
                    <Header>Branch Manager</Header>
                    <BranchEmployeeItem branchEmployee={location.branchManager} />
                </LeftCol>
            )}

            <RightCol>
                <Header>Sales Representatives</Header>
                <SalesReps>
                    {location.nonManagerEmployees &&
                        location.nonManagerEmployees.map(
                            (branchEmployee, index) => (
                                <BranchEmployeeItem
                                    key={index}
                                    branchEmployee={branchEmployee}
                                />
                            )
                        )}
                </SalesReps>
            </RightCol>
        </Wrapper>
        <RightCol>
            <Header>Regional Manager</Header>
            <BranchEmployeeItem branchEmployee={location.regionalManager} />
        </RightCol>
    </React.Fragment>
);

export default BranchEmployees;



// WEBPACK FOOTER //
// ./components/details/BranchEmployees.jsx